module.exports = __webpack_public_path__ + "static/media/inedit.78f7caeb.jpg";